export { Device } from './device'
export { User } from './user'
export { Media } from './media'
export { Album } from './album'
export { Curated } from './curated'
export { Tag } from './tag'
export { Category } from './category'
export { Genre } from './genre'
export { Playlist } from './playlist'
export { Contest } from './contest'
export { CategoryMedia } from './category_media'
export { NewsFeedItem } from './news_feed_item'
export { NewsProvider } from './news_provider'
export { CuratedSet } from './curated_set'
export { RadioChartCategory } from './radio_chart_category'
export { Podcast } from './podcast'
export { PodcastCategory } from './podcast_category'
export { BPMPlaylist } from './bpmplaylist'
export { BPMPlaylistCategory } from './bpmplaylist_category'
export { default as CuratedCategory } from './curated_category'
export { PlaylistProvider } from './playlist_provider'
import { fullJsonRegistry } from '../requests/jsonparser'

export function generateRealmModels(): { name: string, properties: any }[] {
    let schemas = new Array<any>();
    Object.keys(fullJsonRegistry).forEach((key) => {
        if (key === 'BaseModel') {
            return
        }
        let object: { properties: { [key: string]: string }, primaryKey?: string, modelName: string, isHelperModel: boolean } = Object.assign({}, fullJsonRegistry[key]);
        if (fullJsonRegistry[key].isHelperModel === false) {
            object.properties = Object.assign(object.properties, fullJsonRegistry['BaseModel'].properties);
        }
        let mappedObject = {};
        Object.keys(object.properties).forEach((key) => {

            if (key === 'id') {
                mappedObject[key] = { 'type': 'string', unique: true }
                return;
            }

            if (typeof object.properties[key] === 'string') {
                switch (object.properties[key].toLowerCase()) {
                    case 'boolean':
                        mappedObject[key] = 'bool';
                        break;
                    case 'boolean?':
                        mappedObject[key] = 'bool?';
                        break;
                    case 'number':
                        mappedObject[key] = 'float';
                        break;
                    case 'number?':
                        mappedObject[key] = 'float?';
                        break;
                    case 'string':
                        mappedObject[key] = 'string';
                        break;
                    case 'string?':
                        mappedObject[key] = 'string?';
                        break;
                    case 'number[]':
                        mappedObject[key] = 'float[]';
                        break;
                    default:
                        mappedObject[key] = object.properties[key];
                        break;
                }
            }
        });

        let scheme: any = {
            name: fullJsonRegistry[key].modelName,
            properties: mappedObject
        }
        if (fullJsonRegistry[key].isHelperModel === false) {
            scheme.primaryKey = 'id';
        }
        schemas.push(scheme)
    });


    return schemas
}



// WEBPACK FOOTER //
// ./src/api/src/models/index.ts